import React from 'react';

import { Flex, Select, Text } from '@mantine/core';
import { ESortStates, SortIcon } from 'visyn_core/vis';

import { SortDirection } from '../utils';

export enum ExperimentOrganismFilter {
  ALL = 'all',
  HUMAN = 'human',
  MOUSE = 'mouse',
}
export enum ExperimentSortField {
  TITLE = 'title',
  CREATION_DATE = 'creationDate',
}

interface ExperimentSortAndFilterProps {
  organismFilter: ExperimentOrganismFilter;
  setOrganismFilter: (value: ExperimentOrganismFilter) => void;
  sortField: ExperimentSortField;
  setSortField: (value: ExperimentSortField) => void;
  sortDirection: SortDirection;
  setSortDirection: (value: SortDirection) => void;
}

export function ExperimentsSortAndFilter({
  organismFilter,
  setOrganismFilter,
  sortField,
  setSortField,
  sortDirection,
  setSortDirection,
}: ExperimentSortAndFilterProps) {
  return (
    <Flex justify="flex-end" align="center" gap="xl">
      <Flex justify="flex-end" align="center" gap="xs">
        <Text size="sm">Sort by:</Text>
        <Select
          checkIconPosition="right"
          rightSection={
            <div style={{ pointerEvents: 'all' }}>
              <SortIcon
                hasUnsortedState={false}
                sortState={sortDirection === SortDirection.ASC ? ESortStates.ASC : ESortStates.DESC}
                setSortState={(value) => {
                  setSortDirection(value === 'asc' ? SortDirection.ASC : SortDirection.DESC);
                }}
                sortStateOnFirstClick={ESortStates.ASC}
              />
            </div>
          }
          data={[
            { value: ExperimentSortField.TITLE, label: 'Title' },
            { value: ExperimentSortField.CREATION_DATE, label: 'Creation date' },
          ]}
          value={sortField}
          onChange={(value) => {
            if (value) {
              setSortField(value as ExperimentSortField);
            }
          }}
        />
      </Flex>
    </Flex>
  );
}
